import { pickBy } from 'lodash';
import axios from 'axios';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

let cancelTokenConfig;
export const getReportsConfig = (payload) => {
  if (typeof cancelTokenConfig !== typeof undefined) {
    cancelTokenConfig.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenConfig = axios.CancelToken.source();
  return axiosInstance.get('/reports/configuration', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenConfig.token,
  });
};

export const getReportsPaymentsCharts = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/reports/payments/chart', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken,
  });
};

export const getReportsPaymentsTable = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/reports/payments/table', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken,
  });
};

export const getReportsPaymentsConfig = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/reports/payments/configuration', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken,
  });
};

export const getReportsPaymentsTableConfig = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/reports/payments/table/configuration', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken,
  });
};

export const getReportsPaymentsChartConfig = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/reports/payments/chart/configuration', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken,
  });
};

export const getReportsOrdersTable = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.post('/reports/orders/table', parsedPayload, {
    params: pickDevParams,
    cancelToken,
  });
};

export const getReportsOrdersConfig = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.post('/reports/orders/configuration', parsedPayload, {
    params: pickDevParams,
    cancelToken,
  });
};

export const getReportsTicketsTable = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.post('/reports/tickets/table', parsedPayload, {
    params: pickDevParams,
    cancelToken,
  });
};

export const getReportsServicesTable = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/reports/services/table', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken,
  });
};

export const getReportsUsersTable = (payload, cancelToken) => axiosInstance.get('/reports/users/table', {
  params: { ...payload, ...pickDevParams },
  cancelToken,
});

export const getReportsTicketsConfig = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.post('/reports/tickets/configuration', parsedPayload, {
    params: pickDevParams,
    cancelToken,
  });
};

export const getReportsServicesConfig = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/reports/services/configuration', {
    params: { ...pickDevParams, ...parsedPayload },
    cancelToken,
  });
};

export const getReportsUsersConfig = (payload, cancelToken) => axiosInstance.get('/reports/users/configuration', {
  params: { ...pickDevParams, ...payload },
  cancelToken,
});

export const getReportsProfitsTable = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.post('/reports/profits/table', parsedPayload, {
    params: pickDevParams,
    cancelToken,
  });
};

export const getReportsProfitsConfig = (payload, cancelToken) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.post('/reports/profits/configuration', parsedPayload, {
    params: pickDevParams,
    cancelToken,
  });
};

export const getUsers = (query) => axiosInstance.post('/general/get-users-info', { query }, { params: pickDevParams });
